<template>
    <div class="role_warp">
      <!-- 头部工具栏 -->
      <div class="role_heard_tool">
        <el-button
          type="success"
          size="mini"
          @click="getDate()"
          >刷新</el-button
        >
        <el-button
          type="primary"
          class="edit-button"
          size="mini"
          style="margin-left: 10px"
          @click="select()"
          >筛选</el-button
        >
        <el-button
          type="primary"
          class="edit-button"
          size="mini"
          style="margin-left: 10px"
          @click="applyCount()"
          >待审核 {{ count || 0 }}</el-button
        >
        <el-button
          type="primary"
          class="edit-button"
          size="mini"
          style="
            margin-left: 10px;
            background: #06cc00;
            border: 1px solid #06cc00;
          "
          @click="getZhuanList()"
          >批量立即转账</el-button
        >
        <el-button
          type="primary"
          class="edit-button"
          size="mini"
          style="
            margin-left: 10px;
            background: #F28300;
            border: 1px solid #F28300;
          "
          @click="resetStatus()"
          >恢复待转账状态</el-button
        >
      </div>
      <div class="head_search">
        <div class="item_warp">
          <label style="margin: 0 10px">用户</label>
          <el-input
            v-model="uid"
            placeholder="请输入用户"
            style="width: 120px"
            size="mini"
            clearable
          />
        </div>
        <div class="item_warp">
          <label style="width: 44px">状态</label>
          <el-select v-model="checkStatus" placeholder="请选择" clearable>
            <el-option label="不限" value=""></el-option>
            <el-option label="未转账" value="0"></el-option>
            <el-option label="转账中" value="3"></el-option>
            <el-option label="已转账" value="1"></el-option>
            <el-option label="已拒绝" value="2"></el-option>
            <el-option label="转账失败" value="4"></el-option>
          </el-select>
        </div>
        <div class="item_warp">
          <label style="margin: 0 10px">提币地址</label>
          <el-input
            v-model="address"
            placeholder="请输入提币地址"
            style="width: 120px"
            size="mini"
            clearable
          />
        </div>
      </div>
      <div class="content">
        <div class="head_search" style="margin-bottom: 0px;">
          <div class="item_warp">
            <label style="margin: 0 10px"
              >自动转账条件（全部满足）：实际到账金额小于:</label
            >
            <el-input
              v-model="active.lessAmount"
              placeholder="请输入到账金额"
              style="width: 100px"
              size="mini"
              clearable
            />
          </div>
          <div class="item_warp">
            <label style="margin: 0 10px">累计充值金额大于</label>
            <el-input
              v-model="active.moreRecharge"
              placeholder="请输入到账金额"
              style="width: 100px"
              size="mini"
              clearable
            />
          </div>
          <div class="item_warp">
            <label style="margin: 0 10px">VIP:</label>
            <el-radio-group
              style="display: flex"
              v-model="active.requiredVipLevel"
            >
              <el-radio :label="0">不限</el-radio>
              <el-radio :label="1">是</el-radio>
            </el-radio-group>
          </div>
        </div>
        <div style="display: flex;align-items: center;">
  <div class="item_warp">
            <label style="margin: 0 10px">自动转账设置:</label>
            <el-checkbox v-model="active.isEnableZhuan">开启</el-checkbox>
          </div>
          <div class="item_warp">
            <label style="margin: 0 10px"></label>
            <el-button
              type="success"
              size="mini"
              style="background: #6663ff;border:none;"
              @click="updateAutoShenhe()"
              >保存</el-button
            >
          </div>
        </div>
      </div>
      <div class="head_search">
        <div class="item_warp">
          <div style="color: red">
            实际转出:{{ amount || 0 }} 
          </div>
        </div>
      </div>
      <!-- 表单 -->
      <el-table
        ref="gridTable"
        v-loading="loading"
        :data="tableData"
        tooltip-effect="dark"
        :stripe="true"
        :border="true"
        height="calc(100vh - 240px )"
        style="width: 1781px"
        size="mini"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          type="selection"
          width="50"
          :selectable="checkSelectable"
        />
        <el-table-column prop="address" label="转账状态" width="170">
          <template slot-scope="scope">
            <div>
              <div
                class=""
                v-if="scope.row.status != 1 && scope.row.status != 2 && scope.row.status != 3 && scope.row.status != 4"
              >
                  <el-button
                  type="primary"
                  class="edit-button"
                  style="background: #06cc00; border: none"
                  size="mini"
                  @click="getMemberTiePass(scope.row)"
                  >立即转账</el-button
                >
                  <el-button
                  type="primary"
                  class="edit-button"
                  style="background: #ff0000; border: none"
                  size="mini"
                  @click="memberTieReject(scope.row)"
                  >拒绝转账</el-button
                >
              </div>
              <div v-if="scope.row.status == 1" style="color: #06cc00">
                已转账
              </div>
              <div v-if="scope.row.status == 2" style="color: #ff0000">
                已拒绝
              </div>
              <div v-if="scope.row.status == 3" style="color: #ccc">
                转账中
              </div>
              <div v-if="scope.row.status == 4" style="color: #ff0000">
                转账失败X{{scope.row.failCount}}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="memberUid" label="用户" width="100" />
        <el-table-column prop="amount" label="提现金额" width="100" />
        <el-table-column prop="address" label="实际到账" width="100">
          <template slot-scope="scope">
            <div style="color:red;font-weight: 600;">
              {{ scope.row.reachAmount }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="address" label="金额详情" width="160">
          <template slot-scope="scope">
            <div>
              <div>提现前：{{ scope.row.beforeAmount }}</div>
              <div>提现后：{{ scope.row.afterAmount }}</div>
              <div>手续费：{{(Number(scope.row.chargeFee) + Number(scope.row.platformFee)).toFixed(2) }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="address" label="手续费模式" width="100">
          <template slot-scope="scope">
            <div>
              <div v-if="scope.row.chargeType == 0">单笔固定</div>
              <div v-if="scope.row.chargeType == 1">按提现金额比例</div>
            </div>
          </template>
        </el-table-column>
        
        <el-table-column prop="address" label="审核时间" width="100">
          <template slot-scope="scope">
            <div>
              <div>
                {{ scope.row.checkPassDate?happenTimeFun(scope.row.checkPassDate):'' }}
              </div>
              
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="address" label="提币地址" width="150" />
        <el-table-column prop="zhuanAddress" label="转出地址" width="150" />
        <el-table-column prop="memo" label="备注" width="100" />
        <el-table-column prop="yifangUsername" label="乙方" width="100" />
        <el-table-column
          prop="adminUsername"
          label="审核操作管理员"
          width="120"
        />
        <el-table-column prop="address" label="IP" width="160">
          <template slot-scope="scope">
            <div>
              <div>{{ scope.row.ip }}</div>
              <div>{{ scope.row.ipAddress }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="createDate" label="创建时间" width="170" />
      </el-table>
      <!-- 分页 -->
      <pagination
        v-show="total > 0"
        :total="total"
        :page.sync="pageNum"
        :limit.sync="pageSize"
        @pagination="getList"
      />
      <!-- 归集主账号 -->
      <el-dialog
        :visible.sync="editPasswordShow"
        width="400px"
        :center="true"
        title="主账号选择"
        :close-on-click-modal="false"
      >
        <div>
          <div style="margin: 15px 0" class="radioGroup">
            <el-radio-group v-model="masterAccountId">
              <el-radio style="white-space: break-spaces;" v-for="(item,index) in masterAccountList" :key="index" :label="item.id">
                {{item.address}}<span v-if="item.memo" style="margin-left: 10px;">({{item.memo}})</span>
              </el-radio>
            </el-radio-group>
          </div>
          <div style="display: flex;justify-content: center;" v-if="type == 1">
            <el-button
              type="primary"
              class="edit-button"
              @click="checkSuccessList()"
              >确定</el-button
            >
          </div>
          <div style="display: flex;justify-content: center;" v-if="type == 2">
            <el-button
              type="primary"
              class="edit-button"
              @click="memberTiePass()"
              >确定</el-button
            >
          </div>
        </div>
      </el-dialog>
    </div>
  </template>
  <script>
  import Pagination from "@/components/Pagination"; // 引入分页器
  import VueUeditorWrap from "vue-ueditor-wrap"; // ES6 Module
  import validEmail from "@/utils/validate"; // 引入邮箱验证方法
  import md5 from "js-md5"; // 引入Md5加密
  
  export default {
    name: "Management",
    components: { Pagination, VueUeditorWrap },
    data() {
      return {
        tableData: [], // 展示的表单信息
        total: 0, // 总数
        pageNum: 1, // 页码值
        pageSize: 20, // 页大小
        loading: false, // 表格加
        uid: "",
        address: "",
        ipAddress: "",
        checkStatus: "",
        ip: "",
        yifangUsername: "",
        dataTime: ["", ""],
        amount: "",
        chargeFee: "",
        active: {},
        count: 0,
        editDialogVisible: false,
        editPasswordShow: false,
        masterAccountId:'',
        id:'',
        type:1,
        masterAccountList:[],
        multipleSelection:[]
      };
    },
    mounted() {
      this.getDate();
      this.autoShenhe();
    },
    methods: {
      totalAmount(){
        var params = {
          pageNumber: this.pageNum,
          pageSize: this.pageSize,
          uid: this.uid,
          status: this.checkStatus,
          address: this.address
        };
        this.$api.Polygon
          .withdrawTransferTotalAmount(params)
          .then((res) => {
            this.amount = res.amount;
          })
          .catch((err) => {
            this.$message.error(err || "服务器错误，请稍后重试");
          })
          .finally(() => {
            this.loading = false;
          });
      },
      editClose() {},
      getZhuanList() {
        if (!this.multipleSelection || this.multipleSelection.length < 1) {
          return this.$message.info("你并没有选中任何选项");
        }
        this.type = 1
        this.$api.Polygon
          .masterAccounts()
          .then((res) => {
            if(res.length > 0){ 
              this.editPasswordShow = true
              this.masterAccountList = res
            }else{
              this.$message.info("暂无主体");
            }
          })
          .catch((err) => {
            this.$message.error(err || "服务器错误，请稍后重试");
          })
          .finally(() => {
            this.loading = false;
          });
      },
      resetStatus() {
        if (!this.multipleSelection || this.multipleSelection.length < 1) {
          return this.$message.info("你并没有选中任何选项");
        }
        var ids = [];
          this.multipleSelection.forEach((item) => {
            ids.push(item.id);
          });
          var params = {
            ids: ids.toString()
          };
        this.$api.Polygon
          .withdrawTransferBnbResetStatus(params)
          .then((res) => {
            if(res.length > 0){ 
               this.$message.success(res);
            }else{
              this.$message.info("暂无主体");
            }
          })
          .catch((err) => {
            this.$message.error(err || "服务器错误，请稍后重试");
          })
          .finally(() => {
            this.loading = false;
          });
      },
      happenTimeFun(num) {
        let date = new Date(num);
        //时间戳为10位需*1000，时间戳为13位的话不需乘1000
        let y = date.getFullYear();
        let MM = date.getMonth() + 1;
        MM = MM < 10 ? "0" + MM : MM; //月补0
        let d = date.getDate();
        d = d < 10 ? "0" + d : d; //天补0
        let h = date.getHours();
        h = h < 10 ? "0" + h : h; //小时补0
        let m = date.getMinutes();
        m = m < 10 ? "0" + m : m; //分钟补0
        let s = date.getSeconds();
        s = s < 10 ? "0" + s : s; //秒补0
        return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
      },
      // 自动审核设置 更新接口：
      updateAutoShenhe() {
        this.$api.Polygon
          .updateAutoZhuan(this.active)
          .then((res) => {
            this.$message.success(res);
            this.autoShenhe();
          })
          .catch((err) => {
            this.$message.error(err || "服务器错误，请稍后重试");
            this.autoShenhe();
          })
          .finally(() => {
            this.loading = false;
          });
      },
      // 自动审核设置 回显接口：
      autoShenhe() {
        this.$api.Polygon
          .autoZhuan()
          .then((res) => {
            this.active = res;
          })
          .catch((err) => {
            this.$message.error(err || "服务器错误，请稍后重试");
          })
          .finally(() => {
            this.loading = false;
          });
      },
      // 选择或者取消行，支持全选
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      checkSelectable(row) {
        // if (row.status == 0 || row.status == 4) {
        //   return true;
        // } else {
        //   return false;
        // }
        return true;
      },
      getMemberTiePass(row){
        this.id = row.id
        this.type = 2 
        this.$api.Polygon
          .masterAccounts()
          .then((res) => {
            if(res.length > 0){
              this.editPasswordShow = true
              this.masterAccountList = res
            }else{
              this.$message.info("暂无主体");
            }
          })
          .catch((err) => {
            this.$message.error(err || "服务器错误，请稍后重试");
          })
          .finally(() => {
            this.loading = false;
          });
  
  
      },
      // 通过转账
      memberTiePass(row) {
          var params = {
            id:this.id,
            masterAccountId:this.masterAccountId
          };
          this.$api.Polygon
            .zhuan(params)
            .then((res) => {
              this.$message.success(res);
              this.editPasswordShow = false
              this.getList();
            })
            .catch((err) => {
              this.$message.error(err || "服务器错误，请稍后重试");
            })
             
      },
      // 拒绝转账
      memberTieReject(row) {
        this.$confirm("是否拒绝转账?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.$api.Polygon
              .reject({
                id: row.id,
              })
              .then((res) => {
                this.$message.success(res);
                this.getList()
              })
              .catch((err) => {
                this.$message.error(err || "服务器错误，请稍后重试");
              })
              .finally(() => {
  
              });
          })
          .catch(() => {
            
          });
      },
      // 批量转账
      checkSuccessList() {
        var ids = [];
          this.multipleSelection.forEach((item) => {
            ids.push(item.id);
          });
          var params = {
            ids: ids.toString(),
            masterAccountId:this.masterAccountId
          };
          this.$api.Polygon
            .zhuanList(params)
            .then((res) => {
              this.$message.success(res);
              this.editPasswordShow = false
              this.getList();
            })
            .catch((err) => {
              this.$message.error(err || "服务器错误，请稍后重试");
            })
      },
      applyCount() {
        this.checkStatus = "0";
        this.select();
      },
      getApplyCount() {
        this.$api.Polygon
          .applyCount()
          .then((res) => {
            this.count = res;
          })
          .catch((err) => {
            this.$message.error(err || "服务器错误，请稍后重试");
          })
          .finally(() => {
            this.loading = false;
          });
      },
      // 筛选
      select() {
        this.pageNum = 1;
        this.getList();
        this.getApplyCount();
      },
      getDate() {
        this.getList();
        this.getApplyCount();
      },
      // 获取表单信息
      getList() {
        this.totalAmount()
        var params = {
          pageNumber: this.pageNum, 
          pageSize: this.pageSize,
          uid: this.uid,
          status: this.checkStatus,
          address: this.address
        };
        this.loading = true;
        this.$refs.gridTable.bodyWrapper.scrollTop = 0;
        this.$api.Polygon
          .withdrawTransfer(params)
          .then((res) => {
            this.tableData = res.records;
            this.total = res.total;
          })
          .catch((err) => {
            this.$message.error(err || "服务器错误，请稍后重试");
          })
          .finally(() => {
            this.loading = false;
          });
      },
    },
  };
  </script>
  <style lang="scss" scoped>
  .role_warp {
    width: 100%;
    overflow: hidden;
    font-size: 14px;
    padding: 10px;
    box-sizing: border-box;
    .role_heard_tool {
      margin-bottom: 10px;
    }
    .edit_titile {
      .dialog_input {
        // width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-around;
        width: 70%;
        span {
          flex: 1;
          display: flex;
          justify-content: flex-end;
          margin-right: 20px;
        }
        .el-input {
          flex: 3;
        }
      }
    }
    .tree {
      margin-top: 25px;
      display: flex;
      justify-content: space-around;
    }
    .authority_info {
      margin-top: 25px;
    }
  }
  .el-input {
    width: 70%;
  }
  .content {
    border: 2px dashed #000;
    padding-left: 10px;
    padding-bottom: 10px;
    padding-top: 10px;
  }
  // ::v-deep .radioGroup .el-radio-group{
  //   display: flex;
  //     flex-direction: column;
  // }
  // ::v-deep .radioGroup .el-radio{
  //   margin-bottom: 10px;
  // }
  ::v-deep .el-radio{
    margin-bottom: 10px !important;
  }
  </style>
  